module.exports = __webpack_public_path__ + "img/shuang11-icon.398b57a7.jpg";